/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import './transfer';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "models": {
            "nested": {
              "Transaction": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "masterId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "customerId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "accountId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "settledAt": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "voidedAt": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "availableAt": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.sfs.models.Transaction.Status",
                    "id": 10,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "friendlyType": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "originatingBankName": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "savingsTransferType": {
                    "type": ".squareup.sfs.models.TransferType",
                    "id": 15,
                    "rule": "optional"
                  },
                  "returnCode": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "externalAccountNumberSuffix": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "runningAccountBalance": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 18,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "TRANSACTION_STATUS_DO_NOT_USE": 0,
                      "INITIATED": 1,
                      "PENDING": 2,
                      "SETTLED": 3,
                      "VOIDED": 4
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.models?.nested?.Transaction && !$root.nested?.squareup?.nested?.sfs?.nested?.models?.nested?.Transaction?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a transferral of funds resulting from initiating a Transfer, interest accrual, manual adjustments, incoming
 * ACH requests, etc.
 * --
 *
 * SOURCE Transaction @ squareup/sfs/models/transaction.proto at 13:1
 */
export const Transaction = $root.lookupType('squareup.sfs.models.Transaction');
fixType(Transaction, {
  id: {
    required: true
  },
  masterId: {
    required: true
  },
  customerId: {
    required: true
  },
  amount: {
    required: true
  },
  createdAt: {
    required: true
  },
  status: {
    required: true
  }
});
Builder.createAndAttachToType(Transaction);
/**
 * SOURCE Status @ squareup/sfs/models/transaction.proto at 14:3
 */
Transaction.Status = $root.lookupEnum('squareup.sfs.models.Transaction.Status').values;